import { RecoilRoot } from 'recoil'
import RootRouter from 'RootRouter'
import Loader from 'components/Loader'

function App() {
  return (
    <div className='App'>
      <RecoilRoot>
        <Loader></Loader>
        <RootRouter></RootRouter>
      </RecoilRoot>
    </div>
  )
}

export default App
